import "./units.css"
import {Link} from "react-router-dom"
import {List, ListItem} from "material-ui/List"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import React from "react"
import * as Util from "../common"

const M = Util.intlMessages("view.UnitsList")
const UM = Util.intlMessages("units")

function UnitListItemRender(props) {
  const {unitName, url, count, velocity, isProducible} = props
  if (props.isError) return <Util.Error error={props} />
  return (
    <ListItem
      className="navMenuItem"
      containerElement={<Link to={url + "/" + unitName} />}
      primaryText={
        <div>
          <span
            style={{
              display: "inline-block",
              textAlign: "right",
              width: "10em",
            }}
          >
            <Util.Num val={count} />
          </span>{" "}
          <UM id={unitName + ".plural"} values={{count}} />
        </div>
      }
      secondaryText={
        isProducible ? (
          <span
            style={{
              color: "inherit",
              display: "inline-block",
              textAlign: "right",
              width: "14em",
            }}
          >
            <M id="velocity" values={{value: <Util.Num val={velocity} />}} />
          </span>
        ) : null
      }
    />
  )
}
export const UnitListItem = containers.units.UnitListItem(UnitListItemRender)

function UnitListRender(props) {
  const {displayName, unitNames, charId, readonly} = props
  if (props.isError) return <Util.Error error={props} />
  const url = (readonly ? "/c/" : "/p/") + charId + "/units"
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" values={{displayName}} />} />
        </ToolbarGroup>
      </Toolbar>
      <List>
        {unitNames.map(name => (
          <UnitListItem key={name} unitName={name} charId={charId} url={url} />
        ))}
      </List>
    </div>
  )
}
export const UnitListView = containers.units.UnitList(
  Util.DumpProps(UnitListRender),
)



// WEBPACK FOOTER //
// ./src/units/UnitListView.js